const environment = {
    
    ENDPOINT: "/api",
    POPULATE: "?populate=%2A",
    CARDFIELDS: "&fields[0]=Titulo&fields[1]=Language&fields[2]=Categoria"
        
}

export const API = environment;